<template>
    <div class="main">
        <div class="menu">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
                background-color="rgb(250, 250, 250)">
                <el-menu-item index="1">样品样机管理系统</el-menu-item>
            </el-menu>
        </div>
        <div class="sample_select_menu">
            <el-button style="margin-left: 10px;" @click="sample_in" >样品入库登记</el-button>
            <el-button style="margin-left: 20px;" @click="sample_out" >样品出库申请</el-button>
            <el-button style="margin-left: 20px;" @click="prototype">样机管理</el-button>
        </div>
        <div class="sample">
            <router-view :key="$route.fullPath">

            </router-view>
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            options: [{
                value: '李健东',
                label: '李健东'
            }, {
                value: '温智超',
                label: '温智超'
            }, {
                value: '陈志芳',
                label: '陈志芳'
            }, {
                value: '李兆轩',
                label: '李兆轩'
            }, {
                value: '张梅丽',
                label: '张梅丽'
            }, {
                value: '罗航',
                label: '罗航'
            }, {
                value: '张莉敏',
                label: '张莉敏'
            }, {
                value: '卢凤颖',
                label: '卢凤颖'
            }, {
                value: '林宝玲',
                label: '林宝玲'
            }, {
                value: '周才德',
                label: '周才德'
            }, {
                value: '郭诗艺',
                label: '郭诗艺'
            }, {
                value: '陈楚宇',
                label: '陈楚宇'
            }],
        }
    },
    methods: {
        sample_in(){
            this.$router.push({
                    path: '/dashboard/sample_manage/sample_in'
                });
        },
        sample_out(){
            this.$router.push({
                    path: '/dashboard/sample_manage/sample_out'
                });
        },
        prototype(){
            this.$router.push({
                    path: '/dashboard/sample_manage/sample_prototype'
                });
        }
    }
}
</script>
  
<style>
.main {
    height: 100%;
    width: 100%;

}

.sample_select_menu {
    width: 100%;
    height: 4.5%;
    background-color: rgb(250, 250, 250);
}

.sample {
    /* border: 1px solid red; */
    height: 88.9%;
    
}


</style>

<style scoped="scoped">
::v-deep .warm tbody tr>td {
    background-color: rgba(236, 236, 236, 0.8);
}
</style>